import { cn } from "@edusogno/lib/utils";
import { EventsItem, LoginUserItem } from "@/types";
import { useModalAction } from "@/contexts/modal/Context.tsx";
import { getTypeClass } from "@/utils/agenda.ts";
import moment from "moment-timezone";
import GetIcon from "@/components/agenda/desktop/GetEventIcon.tsx";
import { useMe } from "@/data/user";
import { maixpanelTrackEventProps } from "@/mixpanel/MixpanelUtils";
import toTitleCase from "@/utils/title-case";
import { useTimezone } from "@/contexts/TimezoneContext";

const EventItem = (props: EventsItem) => {
  const { selectedTimezone } = useTimezone();
  const {
    data,
    ora,
    isDeleted,
    ora_fine: oraFine,
    user_events: userEvents,
    type,
    nome_visualizzato: nomeVisualizzato,
    titolo,
    titolo_argomento: topic,
    materials,
  } = props;

  const startDate = data
    ? moment
        .tz(`${data}:${ora}`, "YYYY-MM-DD:hh:mm", selectedTimezone)
        .local(true)
    : moment;

  const endTime =
    oraFine == null
      ? moment
          .tz(`${data}:${ora}`, "YYYY-MM-DD:hh:mm", selectedTimezone)
          .add(1, "hour")
          .local(true)
      : moment
          .tz(`${data}:${oraFine}`, "YYYY-MM-DD:hh:mm", selectedTimezone)
          .local(true);
  const isPast = moment().isAfter(endTime, "minutes");
  const isPresent = userEvents[0]?.is_logged_in;

  const { openModal } = useModalAction();

  const duration = endTime.diff(startDate as moment.Moment, "minutes");
  const itemType = type?.toLowerCase();
  const customStyle = getTypeClass(
    itemType,
    nomeVisualizzato || "",
    isPast,
    isDeleted,
  );
  const headerClass = customStyle;
  const modifiedType = nomeVisualizzato;

  const noDesscList = ["one to one", "writing correction"];

  // mixpanel data
  const { me } = useMe();
  const mixpanelPropsData = JSON.stringify(
    maixpanelTrackEventProps("Agenda", me?.item.user as LoginUserItem),
  );

  return (
    <div
      role={"button"}
      tabIndex={0}
      onClick={() =>
        openModal(
          "AGENDA_EVENT_ITEM",
          {
            ...props,
            isPast,
            date: startDate,
            duration,
            endTime,
            materials,
          },
          {
            renderHeader: (
              <div
                className={cn(
                  `w-full flex-row flex justify-between items-center ${headerClass} gap-x-10 h-fit px-4 py-3 rounded-t-md`,
                  `${isPast ? "" : ""}`,
                )}
              >
                <p className={cn(`text-14px font-semibold w-1/2`)}>
                  {toTitleCase(nomeVisualizzato ?? topic)}
                </p>

                {(!noDesscList?.includes(modifiedType?.toLowerCase()) ||
                  isPast) && (
                  <div
                    className={
                      "border-black border flex flex-row flex-grow text-14px gap-1 bg-white items-center justify-center rounded-sm w-1/2"
                    }
                  >
                    <p
                      className={cn(
                        "font-semibold text-primary text-center",
                        `${isDeleted ? "line-through" : ""}`,
                      )}
                    >
                      {toTitleCase(topic as string)}
                    </p>
                  </div>
                )}
              </div>
            ),
            contentClass: "bg-white",
          },
        )
      }
      onKeyUp={(event) => {
        if (event.key === "Enter") {
          openModal("AGENDA_EVENT_ITEM", {
            ...props,
            isPast,
            date: startDate,
            duration,
            endTime,
            materials,
          });
        }
      }}
      className={cn(
        "flex flex-col w-full h-auto rounded-md p-[min(10px,3%)] select-none",
        `${customStyle}`,
      )}
    >
      <div className={"flex flex-row items-center gap-x-2 "}>
        <GetIcon present={isPresent} deleted={isDeleted} past={isPast} />
        <div
          data-track-props={mixpanelPropsData}
          data-track-eventtype={
            type == "Correction"
              ? "Writing Correction"
              : nomeVisualizzato
              ? nomeVisualizzato
              : titolo
          }
          className={
            "flex flex-col text-sm  [&>p]:text-[clamp(8px,5cqmin_+_2px,14px)] [&>h5]:text-[clamp(10px,5cqmin_+_4px,16px)]  "
          }
        >
          <p
            data-track-props={mixpanelPropsData}
            data-track-eventtype={
              type == "Correction"
                ? "Writing Correction"
                : nomeVisualizzato
                ? nomeVisualizzato
                : titolo
            }
            className={cn(`leading-[100%]  xl:line-clamp-1 `)}
          >
            {(startDate as moment.Moment).format("HH:mm")}&nbsp;-&nbsp;
            {endTime.format("HH:mm")}
          </p>
          <p
            data-track-props={mixpanelPropsData}
            data-track-eventtype={
              type == "Correction"
                ? "Writing Correction"
                : nomeVisualizzato
                ? nomeVisualizzato
                : titolo
            }
            className={cn(
              `leading-[120%] font-semibold xl:line-clamp-1 $${
                isPast ? "text-opacity-20" : ""
              } `,
            )}
          >
            {toTitleCase(
              type == "Correction"
                ? "Writing correction"
                : nomeVisualizzato
                ? nomeVisualizzato
                : titolo,
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventItem;
